import React from "react";
import "./BeautyConsultation.css";
import image1 from "../../../Images/1.jpg";
import image2 from "../../../Images/2.jpg";
import image3 from "../../../Images/3.jpg";

export default function BeautyConsultation() {
  return (
    <div className="BeautyConsultationcontainer">
      <div className="grid-container">
        <div className="main-image-section">
          <img
            src={image1}
            alt="Makeup artist applying makeup"
            className="main-image"
          />
          <div className="text-overlay">
            <h2 className="main-text">GLOWING SKIN</h2>
            <h2 className="main-text">STARTS</h2>
            <h3 className="with-you-text">WITH YOU</h3>
          </div>
        </div>

        <div className="top-right-section">
          <img
            src={image2}
            alt="Woman applying makeup"
            className="right-image"
          />
        </div>

        <div className="bottom-right-section">
          <div className="bottom-right-image">
            <img
              src={image3}
              alt="Close-up of woman with professional makeup"
              className="right-image"
            />
          </div>

          <div className="cta-button">
            <div className="cta-content">
              <div className="cta-text-container">
                <div className="cta-text">LET'S</div>
                <div className="cta-text">EXPLORE</div>
              </div>
              {/* New custom arrow element */}
              <div className="custom-arrow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
